import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSwiftSWR } from "../Config";
import { toast } from "react-toastify";

export const useWtcData = (refreshInterval: number | undefined = 10000) => {
  const { t } = useTranslation();

  const [wtc, setWtc] = useState<any[] | []>([]);

  const { data, isLoading, error, mutate } = useSwiftSWR("/wtc/company", {
    refreshInterval,
  });

  useEffect(() => {
    const handleSearchData = () => {
      if (!isLoading && data) {
        setWtc(data.message);
      }
    };

    const handleSearchError = () => {
      if (error) {
        toast.error(
          t(
            error?.response?.data?.message["RESPONSE_CODE"] ||
              "SERVICE_UNAVAILABLE_MESSAGE",
          ),
        );
      }
    };

    handleSearchData();
    handleSearchError();

    // eslint-disable-next-line
  }, [data, isLoading, error]);

  return { wtc, isLoading, error, mutate };
};
